import React from 'react';
import styled from 'styled-components';
import { FOOD_OBJECT_IMAGES, TRAP_OBJECT_IMAGES } from '../common/images';

const StyledGameObject = styled.img.attrs(({ x, y, match }) => ({
  style: {
    top: `${y}px`,
    left: `${x}px`,
    border: `3px solid ${ match ? 'red' : 'none'}`,
    display: match ? 'none' : 'inline'
  }
}))`
  position: absolute;
  transform: translate(-50%, 0);
`

const FoodObjects = {
  bird: {
    img: FOOD_OBJECT_IMAGES.bird,
    width: 50
  },
  frog: {
    img: FOOD_OBJECT_IMAGES.frog,
    width: 50
  },
  mouse: {
    img: FOOD_OBJECT_IMAGES.mouse,
    width: 50
  },
  rabbit: {
    img: FOOD_OBJECT_IMAGES.rabbit,
    width: 50
  },
  squirrel: {
    img: FOOD_OBJECT_IMAGES.squirrel,
    width: 50
  },
};
FoodObjects.values = Object.values(FoodObjects);

const TrapObjects = {
  car: {
    img: TRAP_OBJECT_IMAGES.car,
    width: 160
  },
  dog: {
    img: TRAP_OBJECT_IMAGES.dog,
    width: 100
  },
  excavator: {
    img: TRAP_OBJECT_IMAGES.excavator,
    width: 200
  },
  trap: {
    img: TRAP_OBJECT_IMAGES.trap,
    width: 80
  },
 };

TrapObjects.values = Object.values(TrapObjects);

const getGameObject = (isTrap, typeKey) => isTrap ? TrapObjects[typeKey] : FoodObjects[typeKey];

const getGameObjectWithSeed = (isTrap, seed) => {
  const types = isTrap ? TrapObjects.values : FoodObjects.values;

  return types[seed % types.length];
};

const GameObject = ({
  y,
  x,
  match,
  objectType: {
    img,
    width
  }
}) => {
  return (
    <StyledGameObject
      x={x}
      y={y}
      match={match}
      src={img}
      width={width}
    />
  );
};

export {
  getGameObject,
  getGameObjectWithSeed,
  GameObject,
};
